namespace $.$$ {

	$mol_style_define( $shm_projects_tests, {
		flex: { direction: 'column', grow: 1, shrink: 1 },
		minWidth: 0,
		gap: $mol_gap.block,
		padding: $mol_gap.block,

		Summary: {
			font: { size: '1.1rem', weight: 'bold' },
		},

		Table: {
			flex: { direction: 'column', grow: 1 },
			minWidth: '720px',
		},

		Rows: {
			flex: { direction: 'column' },
		},

		Table_head: {
			display: 'grid',
			gridTemplateColumns: '130px minmax(220px, 1fr) 190px 90px 80px',
			gap: $mol_gap.block,
			padding: $mol_gap.text,
			color: $mol_theme.shade,
			font: { size: '12px', weight: 'bold' },
		},

		Test: {
			display: 'grid',
			gridTemplateColumns: '130px minmax(220px, 1fr) 190px 90px 80px',
			alignItems: 'center',
			gap: $mol_gap.block,
			padding: $mol_gap.text,
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Test_info: {
			flex: { direction: 'column' },
			minWidth: 0,
		},

		Test_title: {
			font: { weight: 'bold' },
			padding: 0,
		},

		Test_source: {
			color: $mol_theme.shade,
			font: { size: '12px', family: 'monospace' },
			padding: 0,
			overflowWrap: 'anywhere',
		},

		Test_open: {
			justifyContent: 'flex-end',
		},
	} )

}
